import type { ReactNode } from "react";
import "./CmsPageHeader.scss";

export interface CmsPageHeaderProps {
  title: string;
  headingLevel?: "h1" | "h2";
  action?: ReactNode;
  center?: ReactNode;
}

/**
 * CMS list page header with a flexible start / center / end grid layout
 */
export function CmsPageHeader({
  title,
  headingLevel = "h1",
  action,
  center,
}: CmsPageHeaderProps) {
  const Heading = headingLevel;

  return (
    <header
      className={[
        "cms-page-header",
        center ? "cms-page-header--with-center" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="cms-page-header__section cms-page-header__section--start">
        <Heading className="cms-page-header__title">{title}</Heading>
      </div>
      {center && (
        <div className="cms-page-header__section cms-page-header__section--center">
          {center}
        </div>
      )}
      {action && (
        <div className="cms-page-header__section cms-page-header__section--end">
          {action}
        </div>
      )}
    </header>
  );
}
